var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content supplier-list"},[_c('CommonTable',{attrs:{"columns":_vm.columns,"dataSource":_vm.tableData,"total":_vm.total},on:{"update:columns":function($event){_vm.columns=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }